module.exports = __webpack_public_path__ + "static/media/it.fdfccf7b.jpg";